import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useAutoreviewerResultsAdapterCard from './useAutoreviewerResultsAdapterCard';
import { Filters } from '@scale/compass-ui/components/filters/Filters';
import { COLUMN_ID_TO_OPTIONS } from 'react-scale/corp/views/DataCompassCardsV2/components/filters/inputFilterOptions';
import { AUTOREVIEWER_RESULTS_INPUT_COLUMNS } from './constants';

const AutoreviewerResultsAdapterCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const { filter, setFilter } = useAutoreviewerResultsAdapterCard(index);

  return (
    <div className="flex flex-col gap-4">
      <Filters
        columns={Object.values(AUTOREVIEWER_RESULTS_INPUT_COLUMNS)}
        filters={filter}
        setFilters={setFilter}
        columnOptionMap={COLUMN_ID_TO_OPTIONS}
      />
    </div>
  );
};

export default AutoreviewerResultsAdapterCardComponent;
